import { FS_FIELD_REASON_MESSAGES } from './constants';

export const FS_GENERIC_REVIEW_LINE = 'Some deal details need review.';

export const resolveFsReasonCopy = (canonicalField: string): string | undefined => FS_FIELD_REASON_MESSAGES[canonicalField];
